import { Routes } from './routes';

export const App_text = {
    //====================== ADMIN ROUTES ======================
    APP_NAME: 'Global Morocco',

    defaults: {
        images: {
            banner_single_page: `${process.env.NEXT_PUBLIC_CDN_SUBDOMAIN}/storage/media/other/morocco-tours-banner_1747478482.webp`,
            card_type_thumbnail: `${process.env.NEXT_PUBLIC_CDN_SUBDOMAIN}/storage/media/other/morocco-tours-placeholder.jpg`,
            cover_page: '/media/default-cover.webp',
            tour_card: `${process.env.NEXT_PUBLIC_CDN_SUBDOMAIN}/storage/media/other/morocco-tours-placeholder.jpg`,
            gallery: '/media/H5-img-6.jpg',
            destination: '/media/H5-img-6.jpg',
            article: '/media/blog-06-740x560.jpg',
            background: '/media/bg-testiminials.png',
            icon: '/media/icon-placeholder.png',
            event: '/media/tour-06.jpg',
        },
        no_content_message: 'No content available at the moment.',
    },

    // Site metadata for SEO
    siteMetadata: {
        keywords: 'Morocco tours, Marrakech events, private tours, holiday packages, corporate events, travel, Morocco excursions, Morocco travel agency',
        robots: 'index, follow',
        viewport: 'width=device-width, initial-scale=1',
        themeColor: '#ffffff',
        locale: 'en_US',
        type: 'website',
        card: 'summary_large_image',
    },
    facilities_single_section: {
        title: 'Facilities:',
    },
    destination_single_section: {
        title: 'Destinations:',
    },
    // Advanced SEO configuration
    seo: {
        // Default values for metadata generation
        defaults: {
            defaultImage: '/media/og-image-default.jpg',
            defaultImageWidth: '1200',
            defaultImageHeight: '630',
            defaultRobots: 'index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1',
            noindexRobots: 'noindex,nofollow',
            defaultLocale: 'en_US',
            defaultType: 'website',
            defaultTwitterCard: 'summary_large_image',
            defaultTwitterSite: '@morocco_tours',
        },
        // Organization information for structured data
        organization: {
            name: 'Global Morocco',
            description: 'Global Morocco offers guided tours, excursions, tailor-made travel experiences, and event planning services throughout Morocco.',
            logo: '/logo.png',
            address: {
                streetAddress: 'Imm. 54, 1er étage App.n° 01 El Maazouzia, Al Massar',
                addressLocality: 'Marrakech',
                addressRegion: 'Marrakech-Safi',
                postalCode: '40000',
                addressCountry: 'Morocco',
            },
            geo: {
                latitude: 31.6755595,
                longitude: -8.03693,
            },
            telephone: '+(212) 524 358 589',
            email: 'sales@morocco-tours.com',
            openingHours: 'Mo-Sa 07:00-20:00, Su 08:00-18:00',
            openingHoursSpecification: [
                {
                    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
                    opens: '07:00',
                    closes: '20:00',
                },
                {
                    dayOfWeek: ['Saturday'],
                    opens: '08:00',
                    closes: '18:00',
                },
                {
                    dayOfWeek: ['Sunday'],
                    opens: '08:00',
                    closes: '18:00',
                },
            ],
            paymentAccepted: 'Cash, Credit Card',
            priceRange: '€',
        },
        // Structured data default values
        structuredData: {
            articlePublisher: 'Global Morocco',
            tourProvider: 'Global Morocco',
            defaultAuthor: 'Global Morocco Editor',
        },
    },
    footer: {
        links: 'Quick links',
        tours: 'Private Tours',
        packages: 'City Breaks',
        events: 'Event planning',
    },
    // home: {
    //     meta_title: 'Home',
    //     meta_description:
    //         'Global Morocco is a premier travel and events agency based in Marrakech, Morocco. With over 17 years of experience, we offer expertly curated private tours, holiday packages, and corporate event planning services across Morocco. From desert excursions to city breaks, our professional team delivers unforgettable, tailored experiences with local expertise and international standards.',
    //     header_video: 'https://across-morocco.com/wp-content/uploads/2024/09/Across-Morocco-Video-720.mp4#t=,39',

    //     after_header: [
    //         {
    //             url: Routes.FRONT_tour,
    //             title: 'Private Tours',
    //             description: "Global Morocco is established in Marrakech, Africa's leading traveler's destination",
    //         },
    //         {
    //             url: Routes.FRONT_city_break,
    //             title: 'City Breaks',
    //             description: "Global Morocco is established in Marrakech, Africa's leading traveler's destination",
    //         },
    //         {
    //             url: Routes.FRONT_events,
    //             title: 'Event planning',
    //             description: "Global Morocco is established in Marrakech, Africa's leading traveler's destination",
    //         },
    //     ],
    //     about: {
    //         action: {
    //             text: 'Book with us now',
    //             url: '#',
    //         },
    //         sub_title: 'Our Rich Experience',
    //         title: 'Over 17 years of experience',
    //         description:
    //             "Global Morocco is established in Marrakech, Africa's leading traveler's destination, by a passionate team with over seventeen years of experience in the travel and events industry. Over the years, we have successfully orchestrated a multitude of events and managed various groups throughout the kingdom, assembling a dedicated team of experts from the realms of events and leisure travel. Whether you are a big national or international corporation with a large budget or a small business with limited financial resources, we have the passion, talent and experience to make your event a unique and memorable occasion that you will look back on with pride.",
    //         url_vd: '//player.vimeo.com/video/916490214?api=false&autopause=true&autoplay=true&byline=true&loop=false&portrait=true&title=true&xhtml=false',
    //         image: '/media/new/about-imgae.jpg',
    //     },
    //     section_h1: {
    //         title: 'Most popular tours',
    //         description:
    //             'Lorem ipsum dolor sit amet. Qui quia reprehenderit in harum exercitationem aut internos deserunt! Et dolorem quia non illo minus qui quos voluptatibus. Eos sequi expedita non error iusto rem velit maiores vel itaque assumenda ut architecto ipsa aut pariatur velit.',
    //     },
    //     section_promo: {
    //         title: 'Promotion',
    //     },
    //     section_tours: {
    //         title: 'Most popular tours',
    //         name_link: 'View all tours',
    //         description:
    //             'Lorem ipsum dolor sit amet. Qui quia reprehenderit in harum exercitationem aut internos deserunt! Et dolorem quia non illo minus qui quos voluptatibus. Eos sequi expedita non error iusto rem velit maiores vel itaque assumenda ut architecto ipsa aut pariatur velit.',
    //     },
    //     section_excursions: {
    //         title: 'Most popular Excursions',
    //         name_link: 'View all excursions',
    //         description:
    //             'Lorem ipsum dolor sit amet. Qui quia reprehenderit in harum exercitationem aut internos deserunt! Et dolorem quia non illo minus qui quos voluptatibus. Eos sequi expedita non error iusto rem velit maiores vel itaque assumenda ut architecto ipsa aut pariatur velit.',
    //     },
    //     section_reviews: {
    //         title: 'Travelers love our locals',
    //         name_link: 'View all reviews',
    //     },
    //     section_blog: {
    //         title: 'Stories, tips, and guides',
    //         name_link: 'View all posts',
    //     },
    //     our_experience: {
    //         sub_title: 'Our Rich Experience',
    //         title: "Our Agency's Key Strengths",
    //         action: {
    //             text: 'Book with us now',
    //             url: '#',
    //         },
    //         description:
    //             "Global Morocco is established in Marrakech, Africa's leading traveler's destination, by a passionate team with over seventeen years of experience in the travel and events industry. Over the years, we have successfully orchestrated a multitude of events and managed various groups throughout the kingdom, assembling a dedicated team of experts from the realms of events and leisure travel. Whether you are a big national or international corporation with a large budget or a small business with limited financial resources, we have the passion, talent and experience to make your event a unique and memorable occasion that you will look back on with pride.",
    //         list_services: [
    //             'Expert venue selection and hotel booking',
    //             'Business Meeting and Conference Coordination',
    //             'Production and Staging Services, including Booths',
    //             'Skilled staffing and entertainment coordination',
    //             'Incentive Trips and Automotive Events',
    //             'Prominent leisure travel and curated tours of Morocco',
    //             'Custom Catering Services for Your Event',
    //             'Transportation Logistics and Team-Building Activities',
    //         ],
    //         list_services_description:
    //             'Partner with Global Morocco for an unmatched event planning experience in Morocco, where we combine passion, talent, and experience to turn your event into a resounding success.',
    //     },
    //     section_services: {
    //         background_image: '/media/new/video-one-bg.jpg',
    //         sub_title: 'Our Proficiencies In Four Key Areas',
    //         title: '4 Areas of expertise working in synergy for more transversality and proximity',
    //         sitle_slide: 'They Trusted Us',
    //         images: [
    //             {
    //                 src: '/media/new/brand-one-1.ae5c8833.png',
    //                 alt: 'Partner brand logo 1',
    //             },
    //             {
    //                 src: '/media/new/brand-one-2.7eed38ec.png',
    //                 alt: 'Partner brand logo 2',
    //             },
    //             {
    //                 src: '/media/new/brand-one-3.13fc9b82.png',
    //                 alt: 'Partner brand logo 3',
    //             },
    //             {
    //                 src: '/media/new/brand-one-4.fad9a9a3.png',
    //                 alt: 'Partner brand logo 4',
    //             },
    //             {
    //                 src: '/media/new/brand-one-5.a52f789d.png',
    //                 alt: 'Partner brand logo 5',
    //             },
    //             {
    //                 src: '/media/new/brand-one-6.3f35e734.png',
    //                 alt: 'Partner brand logo 6',
    //             },
    //             {
    //                 src: '/media/new/brand-one-7.62ca4c87.png',
    //                 alt: 'Partner brand logo 7',
    //             },
    //         ],
    //         list: [
    //             {
    //                 title: 'Evaluate Property',
    //                 icon: 'home',
    //                 description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt',
    //             },
    //             {
    //                 title: 'Meeting with Agent',
    //                 icon: 'building',
    //                 description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt',
    //             },
    //             {
    //                 title: 'Close the Deal',
    //                 icon: 'check-circle',
    //                 description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt',
    //             },
    //             {
    //                 title: 'Close the Deal',
    //                 icon: 'check-circle',
    //                 description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt',
    //             },
    //         ],
    //     },
    //     section_city_breaks: {
    //         title: 'City Breaks & City Break',
    //         name_link: 'View all city breaks',
    //         description:
    //             'Lorem ipsum dolor sit amet. Qui quia reprehenderit in harum exercitationem aut internos deserunt! Et dolorem quia non illo minus qui quos voluptatibus. Eos sequi expedita non error iusto rem velit maiores vel itaque assumenda ut architecto ipsa aut pariatur velit.',
    //     },
    //     destinations: {
    //         sub_title: 'Destination lists',
    //         title: 'Go Exotic Places',
    //         name_link: 'View all destinations',
    //         description:
    //             'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat',
    //     },
    //     events: {
    //         title: 'Corporate & Private Events',
    //         name_link: 'View all events',
    //         description:
    //             'Planning a corporate retreat, a wedding or a private celebration? We design exclusive and tailor-made events in and around Marrakech – to surprise, enchant and to last a lifetime. Discover our packages or contact us to create your own unique experience.',
    //     },
    //     testemonial: {
    //         sub_title: 'Testimonials & reviews',
    //         title: "What They're Saying",
    //         name_link: 'View all city breaks',
    //         description:
    //             'Lorem ipsum dolor sit amet. Qui quia reprehenderit in harum exercitationem aut internos deserunt! Et dolorem quia non illo minus qui quos voluptatibus. Eos sequi expedita non error iusto rem velit maiores vel itaque assumenda ut architecto ipsa aut pariatur velit.',
    //     },
    //     our_vehicles: {
    //         sub_title: 'Our vehicles',
    //         title: '63 vehicles available in our fleet',
    //         description: 'Our fleet comprises 63+ vehicles, from off-road 4x4s to 52-seater buses and vans with 14-19 seats, all modern and well-maintained for an optimal experience.',
    //         url_vd: '//player.vimeo.com/video/916490214?api=false&autopause=true&autoplay=true&byline=true&loop=false&portrait=true&title=true&xhtml=false',
    //         background_image: '/media/new/bg-why-choose-us.jpg',
    //         list: [
    //             {
    //                 title: 'Comfortable vehicles',
    //                 description: 'Travel comfortably in our well-maintained modern vehicles for a safe and enjoyable experience.',
    //             },
    //             {
    //                 title: 'Experienced drivers',
    //                 description: 'Relax on your trip with our skilled, professional drivers for a safe and pleasant journey.',
    //             },
    //         ],
    //     },
    // },
    card_tour: {
        price: 'Price',
        text_price: 'Price on request',
        text_from: 'From',
        text_action: 'More details',
        text_badge_promo: '% Off',
    },
    card_package: {
        starting_point_text: 'Start / End',
        rating_text: '(5★ TripAdvisor Rating)',
        text_action: 'Explore',
        read_less: 'Read Less',
        read_more: 'Read More',
    },
    single_tour: {
        includes: {
            title: "What's Included",
        },
        reviews: {
            title: 'Customer Reviews',
        },
        inquiry: {
            title: 'Get Free Quote',
        },
    },
    side_bar: {
        title_best_tours: 'Top Deals Of The Month',
    },
    blog: {
        categories_title: 'Categories',
        sidebar: {
            title_posts: 'Recent Posts',
            title_categories: 'Blog Categories',
            title_tags: 'Popular Tags',
        },
        button: 'View More',
        meta_title: 'Blog',
        meta_description:
            'Explore Global Morocco travel blog for expert insights, tips, and stories about Morocco. Discover local experiences, destination guides, travel advice, and cultural insights to plan your perfect Moroccan adventure with our Marrakech-based travel experts.',
        title: 'Blog',
        sub_title: 'Blog us sub title',
        description:
            'Lorem ipsum dolor sit amet. Qui recusandae ullam qui officia perferendis 33 debitis galisum. Non atque amet eos sunt magni vel quod praesentium et sapiente maxime id nihil accusantium. 33 placeat sapiente ex molestiae distinctio sed nulla blanditiis qui consequatur tempore. Et quis expedita aut officia quod est quia excepturi qui ipsum debitis sed omnis quos aut nisi impedit.',
    },
    generale: {
        destinations: {
            count_tours: 'Private Tours',
            count_packages: 'City Breaks',
        },
        navbar: {
            packages: 'City Breaks',
            view_all: 'View all',
            home: 'Home',
            tours: 'Private Tours',
            city_break: 'City Breaks',
            events: 'Event planning',
            luxury_travels: 'Exclusive Experiences',
            destinations: 'Destinations',
            travel_guide: 'Travel Guide',
            contact: 'Contact',
            blog: 'Blog',
            articles: 'Articles',
            categories: 'Categories',
            tags: 'Tags',
            button_action: 'Design your trip',
            button_search: 'Search',
            explore: 'Explore',
        },
        currancy: '€',
        articles: 'Articles',
        articles: 'Articles',
        button_contact: 'Post Message',
        spead_dial: {
            whatsap_text: 'Whatsapp',
            email_text: 'Email',
        },
        contact_us: 'Contact us',
        call_us: 'Call us',
        no_reviews: 'No reviews yet',
        text_form_reviews: 'Your email address will not be published. Required fields are marked *',
        text_reviews: ' Reviews',
        text_reviews_2: 'reviews',
        leave_review: 'Leave A Review',
        your_rating: 'Your Rating',
        post_review: 'Post Review',
        no_review_yet: 'No reviews yet',
        load_more: 'Load more',
        view_all: 'View all',
        view_all_offrs: 'View all offers',
        offers: 'Offers',
        mor_details: 'More details',
        attrbute: {
            from: 'Price From',
            price: 'Price',
            start: 'Start From',
            duration: 'Duration',
            destinations: 'Destinations',
            types: 'Type',
            excursion: 'Excursion',
            tour: 'Tour',
            event: 'Event',
            type_field: 'Type',
        },
        recently_viewd: 'Recently Viewed',
        title_related_single: 'Related',
        recently_viewd_title_tours: 'Your recently viewed tours',
        recently_viewd_title_excursions: 'Your recently viewed excursions',
        recently_viewd_title_city_breaks: 'Your recently viewed city breaks',
        filter: {
            filter_by_price: 'Filter by Price',
            price: 'Price:',
            destinations: 'Destinations',
            clear: 'Clear',
            apply: 'Apply',
        },
        banner_single_page: {
            src: '/media/new/banner.png',
            alt: 'banner',
        },
        default_image_seo: '/media/new/background-logo.jpg',
        card_package: {
            price_private: 'Price',
            text_price_private: 'On request',
            text_from: 'From',
            text_action: 'More details',
            text_badge_promo: '% Off',
        },
    },
    why_choose_us: {
        tours: {
            subTitle: 'Why choose us',
            title: 'The wild travel experience, redefined',
            description: "We're not just a travel agency — we're your gateway to nature’s most remote and thrilling adventures.",
            items: [
                {
                    title: 'Expert-guided wild',
                    description: 'Travel with seasoned guides who know every trail, track.',
                },
                {
                    title: 'Safety first, always',
                    description: 'Built-in safety standards, clear planning, and trusted local partners.',
                },
                {
                    title: 'Authentic & responsible',
                    description: 'Experiences designed to respect nature and support local communities.',
                },
                {
                    title: 'Human support',
                    description: 'Fast, friendly assistance before, during, and after your journey.',
                },
            ],
        },
        packages: {
            subTitle: 'Why choose us',
            title: 'Curated journeys tailored for you',
            description: 'Experience the best of Morocco with all-inclusive packages designed for comfort and discovery.',
            items: [
                {
                    title: 'Hand-picked hotels',
                    description: 'Stay in the finest riads and hotels selected for their unique charm and quality.',
                },
                {
                    title: 'Seamless logistics',
                    description: 'We handle all transport and transitions, ensuring a smooth and stress-free journey.',
                },
                {
                    title: 'Best value',
                    description: 'Get the most out of your holiday with premium experiences at competitive rates.',
                },
                {
                    title: 'Stress-free booking',
                    description: 'Focus on making memories while we manage all the technical details of your stay.',
                },
            ],
        },
        events: {
            subTitle: 'Why choose us',
            title: 'Unforgettable events, flawless execution',
            description: 'From corporate retreats to private celebrations, we turn your vision into a remarkable reality.',
            items: [
                {
                    title: 'Strategic planning',
                    description: 'Meticulous coordination for events of any scale, from intimate to grand.',
                },
                {
                    title: 'Elite venues',
                    description: "Access to Morocco's most exclusive and inspiring locations for your event.",
                },
                {
                    title: 'Local expertise',
                    description: 'A vast network of premium local vendors and world-class talent at your service.',
                },
                {
                    title: 'Precision & care',
                    description: 'Every detail is managed with perfection, from inception to the final toast.',
                },
            ],
        },
        luxury: {
            subTitle: 'Why choose us',
            title: 'Exclusive experiences, unmatched luxury',
            description: 'Deeply personal journeys for the discerning traveler seeking the ultimate in privacy and comfort.',
            items: [
                {
                    title: 'Bespoke itineraries',
                    description: 'Completely customized experiences tailored to your every wish and preference.',
                },
                {
                    title: 'VIP access',
                    description: 'Skip the lines and gain exclusive entry to hidden gems across the kingdom.',
                },
                {
                    title: 'Five-star service',
                    description: 'Personalized concierge service and premium private transport for your comfort.',
                },
                {
                    title: 'Ultimate privacy',
                    description: 'Discreet and secure travel arrangements designed for total peace of mind.',
                },
            ],
        },
    },
    breadcrumb: {
        home: 'Home',
        luxury_travels: 'Exclusive Experiences',
        excursions: 'Excursions',
        city_breaks: 'City Breaks',
        tours: 'Private Tours',
        events: 'Event planning',
        destinations: 'Destinations',
    },
    pages_titles: {
        categories: 'Categories',
        tags: 'Tags',
    },
    pages: {
        home: {
            meta_title: 'Home',
            meta_description:
                'Global Morocco is a premier travel and events agency based in Marrakech, Morocco. With over 17 years of experience, we offer expertly curated private tours, holiday packages, and corporate event planning services across Morocco. From desert excursions to city breaks, our professional team delivers unforgettable, tailored experiences with local expertise and international standards.',
            header_video: 'https://across-morocco.com/wp-content/uploads/2024/09/Across-Morocco-Video-720.mp4#t=,39',

            after_header: [
                {
                    url: Routes.FRONT_events,
                    title: 'Event planning',
                    description: "Global Morocco is established in Marrakech, Africa's leading traveler's destination",
                },
                {
                    url: Routes.FRONT_tour,
                    title: 'Private Tours',
                    description: "Global Morocco is established in Marrakech, Africa's leading traveler's destination",
                },
                {
                    url: Routes.FRONT_city_break,
                    title: 'City Breaks',
                    description: "Global Morocco is established in Marrakech, Africa's leading traveler's destination",
                },
            ],
            about: {
                action: {
                    text: 'Book with us now',
                    url: '#',
                },
                sub_title: 'Our Rich Experience',
                title: 'Over 17 years of experience',
                description:
                    "Global Morocco is established in Marrakech, Africa's leading traveler's destination, by a passionate team with over seventeen years of experience in the travel and events industry. Over the years, we have successfully orchestrated a multitude of events and managed various groups throughout the kingdom, assembling a dedicated team of experts from the realms of events and leisure travel. Whether you are a big national or international corporation with a large budget or a small business with limited financial resources, we have the passion, talent and experience to make your event a unique and memorable occasion that you will look back on with pride.",
                url_vd: '//player.vimeo.com/video/916490214?api=false&autopause=true&autoplay=true&byline=true&loop=false&portrait=true&title=true&xhtml=false',
                image: '/media/new/about-imgae.jpg',
            },
            section_h1: {
                title: 'Most popular tours',
                description:
                    'Lorem ipsum dolor sit amet. Qui quia reprehenderit in harum exercitationem aut internos deserunt! Et dolorem quia non illo minus qui quos voluptatibus. Eos sequi expedita non error iusto rem velit maiores vel itaque assumenda ut architecto ipsa aut pariatur velit.',
            },
            section_promo: {
                title: 'Promotion',
            },
            section_tours: {
                title: 'Most popular tours',
                name_link: 'View all tours',
                description:
                    'Lorem ipsum dolor sit amet. Qui quia reprehenderit in harum exercitationem aut internos deserunt! Et dolorem quia non illo minus qui quos voluptatibus. Eos sequi expedita non error iusto rem velit maiores vel itaque assumenda ut architecto ipsa aut pariatur velit.',
            },
            section_excursions: {
                title: 'Most popular Excursions',
                name_link: 'View all excursions',
                description:
                    'Lorem ipsum dolor sit amet. Qui quia reprehenderit in harum exercitationem aut internos deserunt! Et dolorem quia non illo minus qui quos voluptatibus. Eos sequi expedita non error iusto rem velit maiores vel itaque assumenda ut architecto ipsa aut pariatur velit.',
            },
            section_reviews: {
                title: 'Travelers love our locals',
                name_link: 'View all reviews',
            },
            section_blog: {
                title: 'Stories, tips, and guides',
                name_link: 'View all posts',
            },
            our_experience: {
                sub_title: 'Our Rich Experience',
                title: "Our Agency's Key Strengths",
                action: {
                    text: 'Book with us now',
                    url: '#',
                },
                description:
                    "Global Morocco is established in Marrakech, Africa's leading traveler's destination, by a passionate team with over seventeen years of experience in the travel and events industry. Over the years, we have successfully orchestrated a multitude of events and managed various groups throughout the kingdom, assembling a dedicated team of experts from the realms of events and leisure travel. Whether you are a big national or international corporation with a large budget or a small business with limited financial resources, we have the passion, talent and experience to make your event a unique and memorable occasion that you will look back on with pride.",
                list_services: [
                    'Expert venue selection and hotel booking',
                    'Business Meeting and Conference Coordination',
                    'Production and Staging Services, including Booths',
                    'Skilled staffing and entertainment coordination',
                    'Incentive Trips and Automotive Events',
                    'Prominent leisure travel and curated tours of Morocco',
                    'Custom Catering Services for Your Event',
                    'Transportation Logistics and Team-Building Activities',
                ],
                list_services_description:
                    'Partner with Global Morocco for an unmatched event planning experience in Morocco, where we combine passion, talent, and experience to turn your event into a resounding success.',
            },
            section_services: {
                background_image: '/media/new/video-one-bg.jpg',
                sub_title: 'Our Proficiencies In Four Key Areas',
                title: '4 Areas of expertise working in synergy for more transversality and proximity',
                sitle_slide: 'They Trusted Us',
                images: [
                    {
                        src: '/media/new/brand-one-1.ae5c8833.png',
                        alt: 'Partner brand logo 1',
                    },
                    {
                        src: '/media/new/brand-one-2.7eed38ec.png',
                        alt: 'Partner brand logo 2',
                    },
                    {
                        src: '/media/new/brand-one-3.13fc9b82.png',
                        alt: 'Partner brand logo 3',
                    },
                    {
                        src: '/media/new/brand-one-4.fad9a9a3.png',
                        alt: 'Partner brand logo 4',
                    },
                    {
                        src: '/media/new/brand-one-5.a52f789d.png',
                        alt: 'Partner brand logo 5',
                    },
                    {
                        src: '/media/new/brand-one-6.3f35e734.png',
                        alt: 'Partner brand logo 6',
                    },
                    {
                        src: '/media/new/brand-one-7.62ca4c87.png',
                        alt: 'Partner brand logo 7',
                    },
                ],
                list: [
                    {
                        title: 'Evaluate Property',
                        icon: 'home',
                        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt',
                    },
                    {
                        title: 'Meeting with Agent',
                        icon: 'building',
                        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt',
                    },
                    {
                        title: 'Close the Deal',
                        icon: 'check-circle',
                        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt',
                    },
                    {
                        title: 'Close the Deal',
                        icon: 'check-circle',
                        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt',
                    },
                ],
            },
            section_city_breaks: {
                title: 'City Breaks & City Break',
                name_link: 'View all city breaks',
                description:
                    'Lorem ipsum dolor sit amet. Qui quia reprehenderit in harum exercitationem aut internos deserunt! Et dolorem quia non illo minus qui quos voluptatibus. Eos sequi expedita non error iusto rem velit maiores vel itaque assumenda ut architecto ipsa aut pariatur velit.',
            },
            destinations: {
                sub_title: 'Destination lists',
                title: 'Go Exotic Places',
                name_link: 'View all destinations',
                description:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat',
            },
            events: {
                title: 'Corporate & Private Events',
                name_link: 'View all events',
                description:
                    'Planning a corporate retreat, a wedding or a private celebration? We design exclusive and tailor-made events in and around Marrakech – to surprise, enchant and to last a lifetime. Discover our packages or contact us to create your own unique experience.',
            },
            testemonial: {
                sub_title: 'Testimonials & reviews',
                title: "What They're Saying",
                name_link: 'View all city breaks',
                description:
                    'Lorem ipsum dolor sit amet. Qui quia reprehenderit in harum exercitationem aut internos deserunt! Et dolorem quia non illo minus qui quos voluptatibus. Eos sequi expedita non error iusto rem velit maiores vel itaque assumenda ut architecto ipsa aut pariatur velit.',
            },
            our_vehicles: {
                sub_title: 'Our vehicles',
                title: '63 vehicles available in our fleet',
                description: 'Our fleet comprises 63+ vehicles, from off-road 4x4s to 52-seater buses and vans with 14-19 seats, all modern and well-maintained for an optimal experience.',
                url_vd: '//player.vimeo.com/video/916490214?api=false&autopause=true&autoplay=true&byline=true&loop=false&portrait=true&title=true&xhtml=false',
                background_image: '/media/new/bg-why-choose-us.jpg',
                list: [
                    {
                        title: 'Comfortable vehicles',
                        description: 'Travel comfortably in our well-maintained modern vehicles for a safe and enjoyable experience.',
                    },
                    {
                        title: 'Experienced drivers',
                        description: 'Relax on your trip with our skilled, professional drivers for a safe and pleasant journey.',
                    },
                ],
            },
        },
        cover: '/media/Breadcrumb-default.jpg',
        blog: {
            meta_title: 'Blog',
            meta_description:
                'Explore Global Morocco travel blog for expert insights, tips, and stories about Morocco. Discover local experiences, destination guides, travel advice, and cultural insights to plan your perfect Moroccan adventure with our Marrakech-based travel experts.',
            title: 'Blog',
            sub_title: 'Blog us sub title',
            description:
                'Lorem ipsum dolor sit amet. Qui recusandae ullam qui officia perferendis 33 debitis galisum. Non atque amet eos sunt magni vel quod praesentium et sapiente maxime id nihil accusantium. 33 placeat sapiente ex molestiae distinctio sed nulla blanditiis qui consequatur tempore. Et quis expedita aut officia quod est quia excepturi qui ipsum debitis sed omnis quos aut nisi impedit.',
        },
        tags: {
            meta_title: 'Tags',
            meta_description:
                'Browse Global Morocco content by tags to find targeted information about Morocco travel experiences. Discover topics including desert tours, cultural experiences, city guides, and special events organized by our Marrakech-based travel experts.',
            title: 'Tags',
            sub_title: 'Tags us sub title',
            secound_title: 'Custom lorem ipsum',
            description:
                'Lorem ipsum dolor sit amet. Qui recusandae ullam qui officia perferendis 33 debitis galisum. Non atque amet eos sunt magni vel quod praesentium et sapiente maxime id nihil accusantium. 33 placeat sapiente ex molestiae distinctio sed nulla blanditiis qui consequatur tempore. Et quis expedita aut officia quod est quia excepturi qui ipsum debitis sed omnis quos aut nisi impedit.',
        },
        categories: {
            meta_title: 'Categories',
            meta_description:
                'Explore Global Morocco blog categories covering Morocco destinations, travel guides, event planning tips, and cultural insights. Find expert content organized by topic from our Marrakech-based travel specialists to plan your perfect Moroccan experience.',
            title: 'Categories',
            sub_title: 'Categories us sub title',
            secound_title: 'Custom lorem ipsum',
            description:
                'Lorem ipsum dolor sit amet. Qui recusandae ullam qui officia perferendis 33 debitis galisum. Non atque amet eos sunt magni vel quod praesentium et sapiente maxime id nihil accusantium. 33 placeat sapiente ex molestiae distinctio sed nulla blanditiis qui consequatur tempore. Et quis expedita aut officia quod est quia excepturi qui ipsum debitis sed omnis quos aut nisi impedit.',
        },
        contact_us: {
            cover: '/media/Breadcrumb-default.jpg',
            meta_title: 'Contact us',
            meta_description:
                'Connect with Global Morocco, your premier travel and events agency in Morocco. Reach our team in Marrakech for private tours, holiday packages, and corporate event planning. Contact us by phone, email, or visit our office in Al Massar to start planning your perfect Moroccan experience today.',
            meta_keywords: 'contact us, get in touch, Morocco travel contact, Rayanox contact information, travel agency contact, Marrakech travel contact, customer support',
            title: 'Contact',
            sub_title: 'Contact us sub title',
            secound_title: 'Get in touch',
            description_form: 'Your email address will not be published. Required fields are marked *',
            first_card_title: 'Contact us',
            first_card_text_1: 'Call us:',
            first_card_text_2: 'Email:',
            secound_card_title: 'Opening hours',
            secound_card_text_1: 'Mon - Sat: 7.00 am - 8.00 pm',
            secound_card_text_2: 'Sunday: 8.00 am - 6.00 pm',
            therd_card_title: 'Our Office',
            therd_card_text_1: 'Imm. 54, 1er étage App.n° 01 El Maazouzia,',
            therd_card_text_2: 'Al Massar, Marrakech',
            email: 'sales@morocco-tours.com',
            phone: '+(212) 524 358 589',
            whatsapp: '+(212) 770 852 738',
            address: 'Imm. 54, 1er étage App.n° 01 El Maazouzia,  Al Massar, Marrakech',
            description:
                'Lorem ipsum dolor sit amet. Qui recusandae ullam qui officia perferendis 33 debitis galisum. Non atque amet eos sunt magni vel quod praesentium et sapiente maxime id nihil accusantium. 33 placeat sapiente ex molestiae distinctio sed nulla blanditiis qui consequatur tempore. Et quis expedita aut officia quod est quia excepturi qui ipsum debitis sed omnis quos aut nisi impedit.',
        },
        customer_reviews: {
            cover: '/media/Breadcrumb-default.jpg',
            meta_title: 'Customer Reviews',
            meta_description:
                'Read authentic testimonials from travelers who experienced Global Morocco tours and services in Morocco. Discover why guests praise our private tours, holiday packages, and corporate events planning across Marrakech and beyond. Real feedback from satisfied clients sharing their memorable Moroccan adventures.',
            meta_keywords: 'customer reviews, testimonials, Morocco travel reviews, Rayanox reviews, travel experiences, client feedback, travel testimonials, guest reviews',
            title: 'Customer Reviews',
            sub_title: 'Customer Reviews sub title',
            secound_title: 'Customer Reviews',
            description:
                'Lorem ipsum dolor sit amet. Qui recusandae ullam qui officia perferendis 33 debitis galisum. Non atque amet eos sunt magni vel quod praesentium et sapiente maxime id nihil accusantium. 33 placeat sapiente ex molestiae distinctio sed nulla blanditiis qui consequatur tempore. Et quis expedita aut officia quod est quia excepturi qui ipsum debitis sed omnis quos aut nisi impedit.',
        },
        destinations: {
            cover: '/media/Breadcrumb-default.jpg',
            meta_title: 'Destinations',
            meta_description:
                "Discover Morocco's most captivating destinations with Global Morocco. Explore iconic cities like Marrakech, Fes, and Casablanca, venture into the Sahara Desert, or visit the Atlas Mountains. Let our local experts guide you through the diverse landscapes and cultural treasures of Morocco.",
            meta_keywords: 'Morocco destinations, travel destinations, Marrakech, Fes, Casablanca, Atlas Mountains, Sahara Desert, Morocco travel locations',
            title: 'Destinations',
            sub_title: 'Destinations sub title',
            sub_title_1: 'Custom lorem ipsum 1',
            description_1:
                'Lorem ipsum dolor sit amet. Qui recusandae ullam qui officia perferendis 33 debitis galisum. Non atque amet eos sunt magni vel quod praesentium et sapiente maxime id nihil accusantium. 33 placeat sapiente ex molestiae distinctio sed nulla blanditiis qui consequatur tempore. Et quis expedita aut officia quod est quia excepturi qui ipsum debitis sed omnis quos aut nisi impedit.',
            sub_title_2: 'Custom lorem ipsum 2',
            description_2:
                'Lorem ipsum dolor sit amet. Qui recusandae ullam qui officia perferendis 33 debitis galisum. Non atque amet eos sunt magni vel quod praesentium et sapiente maxime id nihil accusantium. 33 placeat sapiente ex molestiae distinctio sed nulla blanditiis qui consequatur tempore. Et quis expedita aut officia quod est quia excepturi qui ipsum debitis sed omnis quos aut nisi impedit.',
        },
        events: {
            cover: '/media/Breadcrumb-default.jpg',
            meta_title: 'Event planning',
            meta_description:
                "Plan exceptional corporate events in Morocco with Global Morocco. Our specialized team designs and executes business meetings, conferences, team building activities, product launches, and corporate retreats across Morocco's most stunning venues with professional service and local expertise.",
            meta_keywords: 'corporate events, Morocco events, business meetings, corporate retreats, conferences, team building, exhibitions, product launches',
            title: 'Event planning',
            sub_title: 'Events sub title',
            sub_title_1: 'Custom lorem ipsum 1',
            description_1:
                'Lorem ipsum dolor sit amet. Qui recusandae ullam qui officia perferendis 33 debitis galisum. Non atque amet eos sunt magni vel quod praesentium et sapiente maxime id nihil accusantium. 33 placeat sapiente ex molestiae distinctio sed nulla blanditiis qui consequatur tempore. Et quis expedita aut officia quod est quia excepturi qui ipsum debitis sed omnis quos aut nisi impedit.',
            sub_title_2: 'Custom lorem ipsum 2',
            description_2:
                'Lorem ipsum dolor sit amet. Qui recusandae ullam qui officia perferendis 33 debitis galisum. Non atque amet eos sunt magni vel quod praesentium et sapiente maxime id nihil accusantium. 33 placeat sapiente ex molestiae distinctio sed nulla blanditiis qui consequatur tempore. Et quis expedita aut officia quod est quia excepturi qui ipsum debitis sed omnis quos aut nisi impedit.',
        },
        excursions: {
            cover: '/media/Breadcrumb-default.jpg',
            meta_title: 'Excursions',
            meta_description:
                'Experience unforgettable day trips and excursions across Morocco with Global Morocco. From desert adventures to mountain hikes, city explorations to coastal escapes, our expertly guided excursions showcase the best of Morocco with comfort, safety and authentic local experiences.',
            title: 'Excursions',
            sub_title: 'Excursions sub title',
            excursions_found: 'Excursions found',
            sub_title_1: 'Custom lorem ipsum 1',
            description_1:
                'Lorem ipsum dolor sit amet. Qui recusandae ullam qui officia perferendis 33 debitis galisum. Non atque amet eos sunt magni vel quod praesentium et sapiente maxime id nihil accusantium. 33 placeat sapiente ex molestiae distinctio sed nulla blanditiis qui consequatur tempore. Et quis expedita aut officia quod est quia excepturi qui ipsum debitis sed omnis quos aut nisi impedit.',
            sub_title_2: 'Custom lorem ipsum 2',
            description_2:
                'Lorem ipsum dolor sit amet. Qui recusandae ullam qui officia perferendis 33 debitis galisum. Non atque amet eos sunt magni vel quod praesentium et sapiente maxime id nihil accusantium. 33 placeat sapiente ex molestiae distinctio sed nulla blanditiis qui consequatur tempore. Et quis expedita aut officia quod est quia excepturi qui ipsum debitis sed omnis quos aut nisi impedit.',
        },
        tours: {
            cover: '/media/Breadcrumb-default.jpg',
            meta_title: 'Morocco Private Tours',
            meta_description:
                "Discover Morocco with Global Morocco personalized private tours. Experience the country's rich culture, stunning landscapes, and historic sites with expert local guides, comfortable transportation, and customized itineraries designed to create unforgettable travel memories throughout Morocco.",
            meta_keywords:
                'private tours, Morocco tours, guided tours, Marrakech tours, travel packages, private tours Morocco, guided tours Morocco, Marrakech tours Morocco, travel packages Morocco',
            title: 'Morocco Private Tours',
            sub_title: 'The best Morocco private adventure tours',
            tours_found: 'Tours found',
            sub_title_1: 'Explore Our Private Tour Packages to Morocco',
            description_1:
                'Are you looking for the best tour packages in Morocco? Discover our carefully curated private tour packages designed to fit your holiday preferences. Our tours include airport pick-up, 4WD and luxury minivan transportation, comfortable accommodations, guided visits, and delicious meals.',
            sub_title_2: '',
            description_2:
                'Visiting Morocco reveals an enticing world with packages covering must-see destinations such as Marrakech, Fes, Rabat, Agadir, Essaouira, Chefchaouen, and Casablanca. We specialize in organizing custom and tailor-made tours, desert trips, holidays, and excursions throughout Morocco. Whether you prefer private or small group tours, we have the perfect package to meet your needs.',
        },
        city_breaks: {
            cover: '/media/Breadcrumb-default.jpg',
            meta_title: 'Morocco City Breaks',
            meta_description: 'Find the best deals on Morocco holidays and vacations. Start planning your dream vacation and relaxing stay in Morocco',
            meta_keywords: 'holiday packages, city breaks, Morocco travel, travel packages, accommodations, Marrakech stays, luxury accommodations',
            title: 'Morocco City Breaks',
            sub_title: 'Find the best deals on Morocco holidays and vacations',
            excursions_found: 'Packages found',
            sub_title_1: 'Start planning your dream vacation and relaxing stays in Morocco',
            description_1:
                'Create lasting memories vacation to Morocco, explore our diverse list of exciting holiday packages, featuring comfortable stays in hotels and luxurious accommodations. Enjoy up to 10% when you bundle your flight + hotel or flight + hotel + car.',
            sub_title_2: '',
            description_2:
                'Experience the beauty of Morocco at an exceptional value for your vacation. Our packages cater to all your holiday needs, from relaxing stays in vibrant cities like Agadir, Marrakech, Fes, Rabat, Casablanca, and Essaouira to tranquil escapes along the coast. Book your all-inclusive hotel and start planning your dream vacation to Morocco today!',
        },
        packages: {
            meta_title: 'Packages',
            meta_description: 'Discover our best Morocco tour packages and customize your trip to Morocco.',
            meta_keywords: 'packages, morocco, marrakech, travel, destinations',
            og_image: '/media/og-packages.jpg',
            og_image_alt: 'Morocco Packages - Travel Destinations',
            title: 'Morocco Packages',
            sub_title: 'Discover our best Morocco tour packages and customize your trip to Morocco.',
            secound_title: 'Discover our best Morocco tour packages and customize your trip to Morocco.',
            description: 'Discover our best Morocco tour packages and customize your trip to Morocco.',
            no_packages_message: 'No packages available at the moment.',
            description_card: 'Discover our best Morocco tour packages and customize your trip to Morocco.',
            no_packages_available: 'No tours or activities available for {packageData}.',
            no_content_available: 'No content available for this destination at the moment.',
        },
        search: {
            cover: '/media/Breadcrumb-default.jpg',
            meta_title: 'Search',
            meta_description:
                'Search Global Morocco extensive collection of Morocco travel experiences, tours, excursions, and event planning services. Find your perfect Moroccan adventure with our easy-to-use search functionality to discover tailored travel experiences from our Marrakech-based experts.',
            title: 'Search',
            sub_title: 'Search sub title',
            secound_title: 'Custom lorem ipsum',
            description:
                'Lorem ipsum dolor sit amet. Qui recusandae ullam qui officia perferendis 33 debitis galisum. Non atque amet eos sunt magni vel quod praesentium et sapiente maxime id nihil accusantium. 33 placeat sapiente ex molestiae distinctio sed nulla blanditiis qui consequatur tempore. Et quis expedita aut officia quod est quia excepturi qui ipsum debitis sed omnis quos aut nisi impedit.',
            resault_found: 'resault found',
            search_for: 'search for: ',
        },
        tailor_made: {
            cover: '/media/Breadcrumb-default.jpg',
            meta_title: 'Tailor made travel',
            meta_description:
                'Create your dream Moroccan journey with Global Morocco tailor-made travel services. Our expert planners customize every aspect of your trip, from luxury accommodations to private transportation, unique excursions to special experiences, all personalized to your preferences and travel style.',
            meta_keywords: 'tailor-made travel, custom travel, personalized tours, bespoke travel, custom Morocco tours, luxury custom travel, private custom tours, custom itineraries',
            title: 'Tailor-made Travel To Morocco',
            sub_title: 'Request A Quote',
            secound_title: 'Request A Quote',
            therd_title: 'Custom lorem ipsum',
            description:
                'Lorem ipsum dolor sit amet. Qui recusandae ullam qui officia perferendis 33 debitis galisum. Non atque amet eos sunt magni vel quod praesentium et sapiente maxime id nihil accusantium. 33 placeat sapiente ex molestiae distinctio sed nulla blanditiis qui consequatur tempore. Et quis expedita aut officia quod est quia excepturi qui ipsum debitis sed omnis quos aut nisi impedit.',
            tabs: {
                titls_1: 'Info',
                short_description_1: 'Name your trip.',
                titls_2: 'Reference',
                short_description_2: 'Travel preferences.',
                titls_3: 'Contact',
                short_description_3: 'Your details.',
                titls_4: 'Submit',
                short_description_4: 'Review & send.',
            },
            description_tab_1: 'Please provide your contact details.',
            description_tab_2: 'Please provide a destination title for your next stay.',
            description_tab_3: 'Who will be part of the stay? Please inform participants.',
            description_tab_4: 'Who will be part of the stay? Please inform participants.',
            description_tab_5: 'Does your stay require a plane ticket reservation ?',
            description_tab_6: 'Does your stay require booking accommodation ?',
            description_tab_7: 'Does your stay require the reservation of a means of transport ?',
            description_tab_8: 'Would you like to book an activity ?',
            description_tab_9: 'What is the total budget allocated to this trip, including all participants ?',
            description_tab_10: 'What will be the spirit of your trip ?',
            description_tab_11: 'Additional information',
            description_tab_12: 'Here is the summary of your stay, please check the request then submit it.',
            description_tab_13: 'Please provide your contact details.',
            button_back: 'Back',
            button_next: 'Next',
            button_submit: 'Submit',
        },
        thank_you: {
            meta_title: 'Thank You for Your Interest in Morocco Tours',
            meta_description:
                'Thank you for contacting Morocco Tours. Your inquiry has been received and our travel experts will respond within 24 hours to help plan your perfect Moroccan adventure.',
            meta_keywords: 'thank you, morocco tours, travel inquiry, contact confirmation',
            og_image: '/media/og-thank-you.jpg',
            og_image_alt: 'Thank You - Morocco Tours',
            title: 'Thank You!',
            sub_title: 'Your Message Has Been Received',

            main_message: 'Thank you ',
            main_message_2: 'for contacting Morocco Tours!',
            description: 'We’ve received your inquiry and our travel team will get back to you ASAP. We look forward to helping you plan an unforgettable Moroccan journey!',
            home_button: 'Return to Homepage',
        },
    },
    form_package: {
        extra_services: 'Extra services',
        cost_extra_services: 'Cost of Extra Activities',
        cost_summary: 'Cost Summary',
        main_activity_price: 'Main Activity Price',
        button_text: 'Book Now',
        button_text_private: 'Ask for a Quote',
        discount_text: '(20% discount)',
        title: 'Request a Quote',
        success_title: 'Thank You!',
        success_message: 'Reservation Submitted Successfully!',
        form_error_message: 'Please correct the errors in the form before submitting.',
        form_title: 'Request for Quote',

        // Form fields
        full_name: 'Full Name',
        email: 'Email',
        phone: 'Phone Number',
        whatsapp: 'Whatsapp Number',
        date: 'Date',
        travel_date: 'Travel Date',
        select_date: 'Select Date',
        date_placeholder: 'Select a date',

        // Starting point
        starting_point_text: 'Start / End',
        duration_text: 'Duration',
        text_type: 'Group Size',
        text_type_private: 'Private',
        text_type_small_group: '12 pers',
        // Guests section
        guests_title: 'Number of Guests',
        adult_label: 'Adult (13-99)',
        adult_limits: 'Minimum:2, Maximum:16',
        child_label: 'Child (6-10)',
        child_limits: 'Minimum:0, Maximum:9',
        infant_label: 'Infant (2-5)',
        infant_limits: 'Minimum:0, Maximum:9',

        // Extras section
        extras_title: 'Do you want extras activities?',
        extras_description: 'Enhance your experience with additional activities and services.',
        extras_options: 'Extra Options',
        extras_select: 'Select additional options for your experience',
        extras_per_person: 'per person',
        extras_not_available: 'This activity is currently not available for any age group.',
        extras_adults: 'Adults',
        extras_children: 'Children',
        extras_infants: 'Infants',
        extras_not_available_adults: 'Not available for adults',
        extras_not_available_children: 'Not available for children',
        extras_not_available_infants: 'Not available for infants',

        // Final details section
        additional_comments: 'Additional details (optional)',
        comments_placeholder: 'Please provide any additional information, special requests, or questions regarding your inquiry.',
        terms_conditions: 'I accept the booking terms and conditions and understand the booking policies.',

        // Buttons
        cancel_button: 'Cancel',
        submit_button: 'Submit Request',
        submitting_button: 'Submitting...',
        close_button: 'Close',

        // Information panel
        info_title: 'Information to be provided',
        info_name: 'Full Name:',
        info_email: 'Email:',
        info_phone: 'Phone:',
        info_date: 'Date:',
        info_date_private: 'Start Date:',
        info_na: 'N/A',
        info_additional: 'Additional Information:',

        // Guests panel
        guests_panel_title: 'Guests',
        guests_adults: 'Adults:',
        guests_children: 'Children:',
        guests_infants: 'Infants:',
        guests_total: 'Total travelers:',
        selected_extras: 'Selected Extras:',
        no_travelers_selected: 'No travelers selected',

        // Cost summary
        cost_summary: 'Cost Summary',
        main_activity_price: 'Main Activity Price',

        // people
        adults_text: 'Adults',
        children_text: 'Children',
        infants_text: 'Infants',

        extras_cost: 'Cost of Extra Activities',
        total: 'Total',
        deposit: 'Deposit (30%)',
        payLater: 'Pay Later',
        // Discount text
        discount_text: '20% discount',

        // Success page
        reservation_details: 'Reservation Details',
        package_label: 'Package:',
        name_label: 'Name:',
        email_label: 'Email:',
        phone_label: 'Phone:',
        date_label: 'Date:',
        travelers_label: 'Travelers:',
        adult_text: 'Adult',
        adults_text: 'Adults',
        child_text: 'Child',
        children_text: 'Children',
        infant_text: 'Infant',
        infants_text: 'Infants',

        // What happens next section
        what_happens_next: 'What Happens Next?',
        next_step_1: 'You will receive a confirmation email with your reservation details',
        next_step_2: 'Our team will contact you soon to confirm your reservation details',
        next_step_3: 'Payment details and instructions will be provided by our team',

        // Card info
        starting_point: 'Starting point',
        duration: 'Duration',
        tags: 'Tags',
        guiders: 'Guiders',
        info_price: 'Price:',
    },
    faqs: {
        title: 'Frequently asked questions',
    },
};
